export default __webpack_public_path__ + "fc789a352a9c7b24b5d912940d4ef8a7.svg";